import { Component, Inject, OnInit } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import {
  MatBottomSheet,
  MatBottomSheetRef,
  MAT_BOTTOM_SHEET_DATA,
} from '@angular/material/bottom-sheet';
import { JwtService } from 'src/app/services/jwt.service';
import { MixpanelService } from 'src/app/services/mixpanel.service';
import { DomSanitizer } from '@angular/platform-browser';
import { MatDialog } from '@angular/material/dialog';
import { UploadDialog } from '../upload-dailog.component';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-micro-learning-content',
  templateUrl: './micro-learning-content.component.html',
  styleUrls: ['./micro-learning-content.component.css'],
})
export class MicroLearningContentComponent implements OnInit {
  buttonClicked = false;
  success = false;
  status;
  sheetNames;

  microLearning = {
    client: null as any,
    sheetName: null as any,
    xl: null as any,
    image: null as any,
  };
  mlPage: boolean;
  factoidPage: boolean;

  constructor(
    private api: ApiService,
    private snackbar: MatSnackBar,
    private _bottomSheet: MatBottomSheet,
    private jwt: JwtService,
    private mixpanel: MixpanelService,
    private sanitizer: DomSanitizer,
    private dialog: MatDialog
  ) {}

  clients = JSON.parse(sessionStorage.getItem('clients'));
  resp = [] as any;

  ngOnInit(): void {
    this.mlPage = window.location.pathname.includes('microlearningjsonexcel');
    this.factoidPage = window.location.pathname.includes('factoidexcel');
    this.mixpanel.track('page_view', {
      page: this.mlPage
        ? 'Micro Learning'
        : this.factoidPage
        ? 'Factoid'
        : 'Mind Body Soul',
      category: 'Dashboard',
      button: '-',
    });
    this.jwt.check();
    this.microLearning.sheetName = localStorage.getItem('ml-xl');
  }

  upload(status: boolean) {
    this.status = status;
    const formData = new FormData();
    formData.append('sheetName', this.microLearning.sheetName);
    formData.append('client', this.microLearning.client);
    formData.append('excelFile', this.microLearning.xl);
    formData.append('zipFile', this.microLearning.image);
    if (status) {
      const dialogRef = this.dialog.open(UploadDialog);
      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.buttonClicked = true;
          this.mixpanel.track('button_click', {
            page: this.mlPage
              ? 'Micro Learning'
              : this.factoidPage
              ? 'Factoid'
              : 'Mind Body Soul',
            category: 'Dashboard',
            button: 'Upload',
          });
          formData.append('commit', 'yes');
          this.apiCall(formData);
        } else {
          //pass
        }
      });
    } else {
      this.buttonClicked = true;
      this.mixpanel.track('button_click', {
        page: this.mlPage
          ? 'Micro Learning'
          : this.factoidPage
          ? 'Factoid'
          : 'Mind Body Soul',
        category: 'Dashboard',
        button: 'Verify',
      });
      this.apiCall(formData);
    }
  }

  apiCall(formData) {
    if (this.mlPage) {
      this.api.microLearning(formData).subscribe(
        (data: any) => {
          this.buttonClicked = false;
          this.success = true;
          if (data.data.length > 0) {
            this.resp = this.sanitizer.bypassSecurityTrustHtml(
              data.data.join('')
            );
          } else {
            this.resp = null;
          }
          this.response(false);
          if (data.status) {
            this.snackbar.open(data.message, undefined, {
              duration: 5000,
              panelClass: 'success',
            });
          } else {
            this.snackbar.open(data.message, undefined, {
              duration: 5000,
              panelClass: 'failure',
            });
          }
        },
        (error) => {
          this.buttonClicked = false;
        }
      );
    } else if (this.factoidPage) {
      this.api.factoid(formData).subscribe(
        (data: any) => {
          this.buttonClicked = false;
          this.success = true;
          if (data.data.length > 0) {
            this.resp = this.sanitizer.bypassSecurityTrustHtml(
              data.data.join('')
            );
          } else {
            this.resp = null;
          }
          this.response(false);
          if (data.status) {
            this.snackbar.open(data.message, undefined, {
              duration: 5000,
              panelClass: 'success',
            });
          } else {
            this.snackbar.open(data.message, undefined, {
              duration: 5000,
              panelClass: 'failure',
            });
          }
        },
        (error) => {
          this.buttonClicked = false;
        }
      );
    } else {
      this.api.mindBodySoul(formData).subscribe(
        (data: any) => {
          this.buttonClicked = false;
          this.success = true;
          if (data.data.length > 0) {
            this.resp = this.sanitizer.bypassSecurityTrustHtml(
              data.data.join('')
            );
          } else {
            this.resp = null;
          }
          this.response(false);
          if (data.status) {
            this.snackbar.open(data.message, undefined, {
              duration: 5000,
              panelClass: 'success',
            });
          } else {
            this.snackbar.open(data.message, undefined, {
              duration: 5000,
              panelClass: 'failure',
            });
          }
        },
        (error) => {
          this.buttonClicked = false;
        }
      );
    }
  }

  remove_xl() {
    this.microLearning.xl = null;
    this.sheetNames = null;
  }

  onFileSelected(event: any): void {
    this.microLearning.xl = event.target.files[0] ?? null;
    const fileReader = new FileReader();
    fileReader.onload = (e) => {
      const workbook = XLSX.read(e.target.result, { type: 'array' });
      this.sheetNames = workbook.SheetNames;
    };
    fileReader.readAsArrayBuffer(this.microLearning.xl);
  }

  remove_img() {
    this.microLearning.image = null;
  }

  onFileSelected1(event: any): void {
    this.microLearning.image = event.target.files[0] ?? null;
  }

  response(status) {
    if (status) {
      this.mixpanel.track('button_click', {
        page: this.mlPage
          ? 'Micro Learning'
          : this.factoidPage
          ? 'Factoid'
          : 'Mind Body Soul',
        category: 'Dashboard',
        button: 'View Log',
      });
    }
    if (this.resp != null) {
      this._bottomSheet.open(MicroLearningResponse, { data: this.resp });
    }
  }

  sheetName() {
    localStorage.setItem('ml-xl', this.microLearning.sheetName);
  }
}

@Component({
  selector: 'microLearning-response',
  templateUrl: './microLearning-response.html',
})
export class MicroLearningResponse {
  constructor(
    private _bottomSheetRef: MatBottomSheetRef<MicroLearningContentComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: []
  ) {}
}
